import { Component, createRef } from "react";
import { NSARouterMakerResult, NSABoxSecret } from "namirasoft-account-react";
import { AWSCreateRow, AWSRow } from "namirasoft-credential";
import { NSBox, NSBoxString, NSBoxTextArea, NSColumn } from "namirasoft-site-react";
import { CredentialEntities } from "../CredentialEntities";
import { CredentialLayout } from '../CredentialLayout';
import { CredentialProps } from "../CredentialProps";

interface AWSEditPageProps extends NSARouterMakerResult, CredentialProps
{
    isEdit: boolean;
}

export default class AWSEditPage extends Component<AWSEditPageProps>
{
    NSBoxString_Name = createRef<NSBoxString>();
    NSABoxSecret_AccessKeySecretID = createRef<NSABoxSecret>();
    NSABoxSecret_SecretKeySecretID = createRef<NSABoxSecret>();
    NSBoxTextArea_Description = createRef<NSBoxTextArea>();
    
    override render()
    {
        return (
            <CredentialLayout<AWSRow, AWSCreateRow>
                {...this.props}
                action={{
                    description: this.props.isEdit ? "This section allows you to edit an Amazon Web Services (AWS) credential by updating its name, access key, secret key, or description. The keys are kept as protected secrets, and any application set up to use the credential applies the updated values." : "This section allows you to create an Amazon Web Services (AWS) credential by entering a name, an access key, and a secret key. Namirasoft encrypts the sensitive data for secure access, and any Namirasoft application you set up to use it can then authenticate to AWS."
                }}
                pages={{
                    entity: CredentialEntities.aws(this.props),
                    edit: {
                        ...this.props,
                        ui: {
                            tab_page_edit: {
                                editor: {
                                    getInputRow: (): AWSCreateRow =>
                                    {
                                        let name = this.NSBoxString_Name.current?.getValue() ?? "";
                                        let access_key = this.NSABoxSecret_AccessKeySecretID.current?.getValue() ?? "";
                                        let secret_key = this.NSABoxSecret_SecretKeySecretID.current?.getValue() ?? "";
                                        let description = this.NSBoxTextArea_Description.current?.getValue() ?? "";

                                        return {
                                            workspace_id: "",
                                            name,
                                            access_key,
                                            secret_key,
                                            description,
                                            aws_category: [],
                                            aws_field: [],
                                            aws_tag: [],
                                        };
                                    },
                                    setRow: (row: AWSRow) =>
                                    {
                                        this.NSBoxString_Name.current?.setValue(row.name);
                                        this.NSABoxSecret_AccessKeySecretID.current?.setValue(row.access_key_secret_id);
                                        this.NSABoxSecret_SecretKeySecretID.current?.setValue(row.secret_key_secret_id);
                                        this.NSBoxTextArea_Description.current?.setValue(row.description);
                                    }
                                }
                            }
                        }
                    }
                }}
            >
                <NSColumn>
                    <NSBoxString
                        ref={this.NSBoxString_Name}
                        required
                        title="Name"
                        auto_complete="new-password"
                        info={{ link: "https://namirasoft.com/credential/console-guide/aws/#field-name" }}
                        style={{ width: NSBox.width.double }}
                    />
                                        <NSABoxSecret
                        ref={this.NSABoxSecret_AccessKeySecretID}
                        {...this.props}
                        required
                        title="Access Key"
                        auto_complete="new-password"
                        info={{ link: "https://namirasoft.com/credential/console-guide/aws/#field-access-key" }}
                        style={{ width: NSBox.width.double }}
                    />
                    <NSABoxSecret
                        ref={this.NSABoxSecret_SecretKeySecretID}
                        {...this.props}
                        required
                        title="Secret Key"
                        auto_complete="new-password"
                        info={{ link: "https://namirasoft.com/credential/console-guide/aws/#field-secret-key" }}
                        style={{ width: NSBox.width.double }}
                    />
                    <NSBoxTextArea
                        ref={this.NSBoxTextArea_Description}
                        required={false}
                        title="Description"
                        info={{ link: "https://namirasoft.com/credential/console-guide/aws/#field-description" }}
                        style={{ width: NSBox.width.double }}
                    />
                </NSColumn>
            </CredentialLayout>
        );
    }
}